import Button from "@/common/components/Button";
import { DateInput } from "@/common/components/DateInput/DateInput";
import TextField from "@/common/components/TextField";
import { UnitTextField } from "@/common/components/UnitTextField";
import { ClockIcon } from "lucide-react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { establishmentChoiceEntryOptions } from "../../../../constants/directiveEntryFormSteps/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant";
import { useCreateForwardingFormStepValidation } from "../../../../hooks/useCreateForwardingFormStepValidation";
import { EstablishmentChoiceEntryAuctionEntrySchema } from "../../../../schemas/entries/establishmentChoiceEntry.schema";
import { useCreateForwardingsFormStore } from "../../../../stores/createForwardingsFormStore";
import { MaintenanceForwardingsDirectiveFromSteps } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepHeader from "../../../CreateForwardingDirectiveEntryFormStepHeader";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass } from "../../../../types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";

const EstablishmentChoiceEntryAuctionEntryPending = () => {
  const {
    increaseStep,
  } = useCreateForwardingsFormStore();

  const {
    control,
    setValue,
  } = useFormContext<EstablishmentChoiceEntryAuctionEntrySchema>();

  const {
    establishment_choice_entry_attributes: watchEstablishmentChoiceEntryAttributes,
  } = useWatch({
    control,
  });

  const { isValid } = useCreateForwardingFormStepValidation(
    MaintenanceForwardingsDirectiveFromSteps.EstablishmentChoiceEntry,
    Object.values(watchEstablishmentChoiceEntryAttributes ?? {})
  );

  const auctionEntryOption = establishmentChoiceEntryOptions[MaintenanceForwardingEstablishmentChoiceEntryKlass.AuctionEntry];

  return (
    <div className="flex flex-col gap-4">
      <CreateForwardingDirectiveEntryFormStepHeader
        goBackAction={() => {
          setValue('establishment_choice_entry_type', undefined!);
          setValue('establishment_choice_entry_attributes', undefined!);
        }}
        title={auctionEntryOption.title}
        description={auctionEntryOption.description}
      />

      <div className="flex flex-col gap-4">
        {/* <SelectController
          control={control}
          name="establishment_choice_entry_attributes.wip_kind"
          options={[]}
          label="Tipo de leilão"
          markAsRequired
        /> */}

        <div className="flex gap-3">
          <Controller
            control={control}
            name="establishment_choice_entry_attributes.minimum_of_proposals_to_finish"
            render={({ field }) => (
              <UnitTextField
                label="Mínimo de propostas para arremate"
                markAsRequired
                unit="Propostas"
                decimals={0}
                className="flex-1"
                {...field}
              />
            )}
          />

          <Controller
            control={control}
            name="establishment_choice_entry_attributes.allowance_radius_in_kilometers"
            render={({ field }) => (
              <UnitTextField
                label="Raio de exibição do leilão"
                markAsRequired
                unit="Km"
                decimals={0}
                className="flex-1"
                {...field}
              />
            )}
          />
        </div>

        {/* <div
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => {
            setValue('establishment_choice_entry_attributes.wip_schedule', !watchEstablishmentChoiceEntryAttributes?.wip_schedule);
          }}
        >
          <Switch
            className='h-8 w-14 border px-[3px] data-[state=unchecked]:border-white-100 data-[state=unchecked]:bg-black-900 data-[state=checked]:border-blue-800 data-[state=checked]:bg-primary-blue'
            thumbClassName='size-6 border transition-transform data-[state=checked]:translate-x-6 data-[state=checked]:bg-white-800 data-[state=checked]:border-blue-800 data-[state=unchecked]:border-black-300'
            checked={!!watchEstablishmentChoiceEntryAttributes?.wip_schedule}
            onClick={(event) => event.stopPropagation()}
            onCheckedChange={(value) => setValue('establishment_choice_entry_attributes.wip_schedule', value)}
          />

          <p className="text-sm flex-1">
            Agendar início de leilão (Se não agendado, iniciará quando finalizado encaminhamento)
          </p>
        </div> */}

        {/* {watchEstablishmentChoiceEntryAttributes?.wip_schedule && ( */}
        <div className="flex gap-3">
          <DateInput
            fieldName="establishment_choice_entry_attributes.finishes_at_date"
            control={control}
            value={watchEstablishmentChoiceEntryAttributes?.finishes_at_date}
            label="Data de encerramento"
            className="flex-1"
            markAsRequired
            minDate={new Date()}
            handleChange={(value) => setValue('establishment_choice_entry_attributes.finishes_at_date', value)}
          />

          <Controller
            control={control}
            name="establishment_choice_entry_attributes.finishes_at_time"
            render={({ field }) => (
              <TextField
                label="Horário de encerramento"
                type="time"
                markAsRequired
                className="flex-1"
                LeftIcon={<ClockIcon className="w-5 h-5 text-white-400" />}
                {...field}
              />
            )}
          />
        </div>
        {/* )} */}
      </div>

      {/* {(!watchEstablishmentChoiceEntryAttributes?.wip_establishments || watchEstablishmentChoiceEntryAttributes?.wip_establishments === '1') && (
        <RadioCards
          options={[
            {
              value: '1',
              title: 'Todos estabelecimentos aptos',
              description: 'Todos Estabelecimentos homologados para seu Equipamento a partir de um raio de X Km do mesmo podem realizar lances.',
            },
            {
              value: '2',
              title: 'Escolher participantes',
              description: 'Defina quais Estabelecimentos homologados podem realizar lances.',
            },
          ]}
          value={watchEstablishmentChoiceEntryAttributes?.wip_establishments}
          onValueChange={(value) => {
            setUpdatedValueAt();
            setValue('establishment_choice_entry_attributes.wip_establishments', value);
          }}
        />
      )} */}

      {/* {watchEstablishmentChoiceEntryAttributes?.wip_establishments === '2' && (
        <Box className="flex flex-col gap-4 p-4">
          <CreateForwardingDirectiveEntryFormStepHeader
            goBackAction={() => {
              setValue('establishment_choice_entry_attributes.wip_establishments', undefined!);
            }}
            title={'Escolher participantes'}
            description={'Defina quais Estabelecimentos homologados podem realizar lances.'}
          />

          <EstablishmentChoiceList
            selectedEstablishmentsIds={selectedEstablishments?.map(({ id }) => id)}
            onSelectEstablishment={(establishment) => {
              if (watchEstablishmentChoiceEntryAttributes?.wip_establishments_ids?.includes(establishment.establishment_id)) {

              }
              if (establishment.establishment_id === watchEstablishmentId) {
                setValue('establishment_choice_entry_attributes.establishment_id', undefined!);
                setSelectedEstablishments([]);

                return;
              }

              setValue('establishment_choice_entry_attributes.establishment_id', establishment.establishment_id);
              setSelectedEstablishments([establishment]);
            }}
          />
        </Box>
      )} */}

      <div className="flex items-center justify-between">
        <p className="text-sm">
          {/* {watchEstablishmentId
            ? '1 Estabelecimento selecionado'
            : 'Nenhum estabelecimento selecionado'} */}
        </p>

        <div className="flex items-center gap-2">
          <Button
            variant="error"
            onClick={() => {
              setValue('establishment_choice_entry_type', undefined!);
              setValue('establishment_choice_entry_attributes', undefined!);
            }}
          >
            Cancelar
          </Button>

          <Button
            onClick={increaseStep}
            disabled={!isValid}
          >
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EstablishmentChoiceEntryAuctionEntryPending;
